import React from 'react';
import { WalletProvider } from './contexts/WalletContext';
import { AppRouter } from './router';
import { Toaster } from 'react-hot-toast'; 
import './index.css';

function App() {
  return (
    <WalletProvider>
      <AppRouter />
      <Toaster 
        position="top-right" 
        reverseOrder={false} 
        gutter={8} 
        toastOptions={{
          className: '',
          duration: 5000, // Durasi default toast (ms)
          style: {
            background: '#363636', 
            color: '#fff',         
            fontSize: '15px',
          },
        
          success: {
            duration: 3000,
            theme: {
              primary: 'green',
              secondary: 'black',
            },
            iconTheme: {
                primary: '#10B981', 
                secondary: '#FFFFFF',
            }
          },
          error: {
            duration: 4000,
            iconTheme: {
                primary: '#EF4444', 
                secondary: '#FFFFFF',
            }
          },
        }}
      />
    </WalletProvider>
  );
}

export default App;